<template lang="pug">
.row
  .centered-content
    h1
      |Stay in control.<br/> Know what's coming.
    .centered-row
      bw-picture-circles
      .left-side
        //h2 A lot of business owners lose sleep over uncertain cash flow...<br/> They don't need to.
        h2 A lot of people lose sleep over uncertain cash flow in their personal and business lives.<br/>You don't have to!
        ul
          li 82% of small business failures are due to poor understanding and management of cashflow.
          li 61% of small business owners struggle with cash flows. 
          li 32% of small business owners couldn’t make various payments.
        h2
          strong It's time to take control
      
      .right-side
        h2 See how easily you can predict your cash flow and reach your personal and business goals with budgee
        p Imagine being able to forecast your future cash flow with the skill of a seasoned spreadsheet guru, in a fraction of the time, without ever touching a spreadsheet. View the effects of potential future events and decisions using scenarios and avoid cash flow holes months out. All of this is easy with Budgee.



        // people want to forecast their cashflow, (ability)
        // so that they can avoid cashflow holes (outcome)
        // so they can stop worrying about going out of business (value)
        // I believe people want to forecast their cashflow so they can avoid cashflow holes and they would pay good money for this to avoid going out of business
        
        // If you value staying in business, you can rapidly forecast your cashflow, try out scenarios, zoom in on tricky timeframes, share cash flows with others for more perspective, simply calculate GST estimates so you can avoid any cashflow holes

        // Relax and put your feet up. You've got this. We've spent years stressing over cash flow so we know how it can be. We thought that there must be a better way of planning things rather than drowning in ever more complex spreadsheets. And lucky you, we figured it out.

        // We know that with the ability to rapidly create a forecast, share it with management, drag amounts around, run scenarios, zoom in on the extra tricky timeframes, that you will get the clarity you need to navigate your business through anything. Making it look easy.
        bw-waitlist
        //a.bw-button.push-button(style="margin-right: 30px; margin-top: 40px; width: fit-content" href="https://freebusy.io/r.j.w.cross@gmail.com/budgee-introduction") 
          span Book your meeting today
           Try Budgee for 2 weeks free

        //form  
          input.text-field(type="text" v-model="email" placeholder="Your email address")
          input.text-field(type="text" v-model="firstName" placeholder="Your name (optional)")
          .bw-button.push-button(
            @click="postForm") Request an Invite
    
</template>

<script>
import BwPictureCircles from "@/components/shared/BwPictureCircles";
import BwWaitlist from "@/components/shared/BwWaitlist";

export default {
  components: {
    BwPictureCircles,
    BwWaitlist
  }
};
</script>

<!-- <script>
export default {
  data: function() {
    return {
      email: "",
      firstName: ""
    };
  },
  methods: {
    postForm() {
      // Create the new request
      var xhr = new XMLHttpRequest();
      var url =
        "https://api.hsforms.com/submissions/v3/integration/submit/7711542/584946c2-5d19-48e6-ae35-c651b2e01df4";

      var date = new Date();
      var timestamp = date.getTime();

      // Example request JSON:
      var data = {
        submittedAt: timestamp,
        fields: [
          {
            name: "email",
            value: this.email
          },
          {
            name: "firstname",
            value: this.firstName
          }
        ],
        context: {
          hutk: "893352c5ff370bbe924a738f9c4ed581", // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
          pageUri: "www.example.com/page",
          pageName: "Example page"
        }
      };

      var final_data = JSON.stringify(data);

      xhr.open("POST", url);
      // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
          alert(xhr.responseText); // Returns a 200 response if the submission is successful.
        } else if (xhr.readyState == 4 && xhr.status == 400) {
          alert(xhr.responseText); // Returns a 400 error the submission is rejected.
        } else if (xhr.readyState == 4 && xhr.status == 403) {
          alert(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.
        } else if (xhr.readyState == 4 && xhr.status == 404) {
          alert(xhr.responseText); //Returns a 404 error if the formGuid isn't found
        }
      };

      // Sends the request
      xhr.send(final_data);
    }
  }
};
</script> -->

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl"
h1
  margin: 0
  text-align: left
  font-weight: 500
  font-size: 50px
  line-height: 60px
  padding-top: 70px
  color: rgba(0,0,0,0.77)
  z-index: 1
  position: relative
h2
  color: rgba(0,0,0,0.67)
  padding-left: 3px
  line-height: 40px
  //margin-bottom: 60px
  font-size: 26px
  font-weight: 400
p
  line-height: 30px
li
  line-height: 30px
  padding-bottom: 6px
.left-side
  display: flex
  flex-direction: column
  width: 50%
  padding-right: 20px
  z-index: 1
.right-side
  display: flex
  width: 50%
  flex-direction: column
  padding-left: 20px
  z-index: 1
.centered-row
  display: flex
  flex-direction: row
  margin-bottom: 110px
  padding-top: 10px

.text-field
  height: 50px
  width: 100%
  min-width: 240px
  border-radius: 4px
  border: 2px solid #aaa
  background: #fafafa
  transition: 0.3s
  outline:none
  padding: 3px 20px
  margin-bottom: 10px
  &:hover, &:active , &:focus
    background: white
    box-shadow: 0 0 5px 3px rgba(0, 100, 0, 0.15)
.bw-button
  //max-width: 250px
  align-self: center
  margin-right: 0
  //max-width: auto
  padding: 20px 35px
  box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)!important
  background: var(--primary-lightened-1)
form
  display: flex
  flex-direction: column
@media mq-tablet
  .right-side, .left-side
    width: 100%
  .centered-row
    flex-direction: column
</style>
